import { Button, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import Loading from "@/components/Loading";
import type { ClientResponse } from "@/lib/types";
import { getCaseSourceLogo } from "@/utils/ExternalPartner/utils";

interface Props {
  addClient: () => void;
  clients: ClientResponse[] | undefined;
  showIfEmpty: boolean;
}

export default function ClientTable({
  addClient,
  clients,
  showIfEmpty = false,
}: Props) {
  return (
    <Loading isLoading={clients === undefined}>
      {(showIfEmpty ||
        (clients?.length !== undefined && clients?.length > 0)) && (
        <div>
          {clients?.length ? (
            <Table striped hover className="client-table">
              <thead>
                <tr className="table-header">
                  <th className="table-header-cell" scope="">
                    Name
                  </th>
                  <th className="table-header-cell" scope="col" />
                </tr>
              </thead>
              <tbody>
                {clients?.map((c) => {
                  return (
                    <tr className="table-row" key={c.id}>
                      <td className="table-cell">
                        <div className="client-name-cell">
                          <span className="client-icon">
                            {getCaseSourceLogo(c.integration?.partner)}
                          </span>
                          <span className="client-name-text">{c.name}</span>
                        </div>
                      </td>
                      <td className="actions-cell">
                        <Link
                          className="btn btn-outline-primary btn-26"
                          to={{
                            pathname: `/clients/${c.id}`,
                            state: {
                              client: c,
                            },
                          }}
                        >
                          View Client
                        </Link>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          ) : (
            <div className="d-flex mt-3 gap-1 align-items-center">
              No Clients:
              <Button variant="link" onClick={addClient} className="p-0">
                Add one now
              </Button>
              or just start by uploading a document.
            </div>
          )}
        </div>
      )}
    </Loading>
  );
}
